import { UITypes } from "types"

import AdhocStatusCell from "components/table/columnComponents/AdhocStatusCell"
import RateCell from "components/table/columnComponents/RateCell"

export const adHocReportHeaderCells: UITypes.TableHeaderCell[] = [
  { title: "Thermostat S/N", type: "sort-search", name: "sn", size: "middle" },
  { title: "Customer Email", type: "sort-search", name: "customer_email", size: "middle" },
  { title: "Status", type: "sort", name: "status", size: "small", cellComponent: AdhocStatusCell },
  {
    title: "Online %",
    type: "sort",
    name: "online_percentage",
    size: "middle",
    cellComponent: RateCell,
  },
  { title: "Address", type: "sort-search", name: "address", size: "middle" },
  { title: "Thermostat Name", type: "sort-search", name: "thermostat_name", size: "middle" },
]
